import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import useChatStore from '@/stores/useChatStore'
import { useToast } from '@/components/ui/use-toast'
import useAuthStore from '@/stores/useAuthStore'
import { ChatInterface } from '@/components/chat/ChatInterface'

const ChatPage = () => {
  const { sessionId: paramSessionId } = useParams<{ sessionId: string }>()
  const navigate = useNavigate()
  const { error, loadSession, sessionId, startNewSession } = useChatStore()
  const { isAuthenticated } = useAuthStore()
  const { toast } = useToast()

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login')
    }
  }, [isAuthenticated, navigate])

  useEffect(() => {
    if (paramSessionId) {
      if (sessionId !== paramSessionId) {
        loadSession(paramSessionId)
      }
    } else {
      navigate('/')
    }
  }, [paramSessionId, sessionId, loadSession, navigate])

  useEffect(() => {
    if (error) {
      if (error.includes('Session not found')) {
        toast({
          variant: 'destructive',
          title: 'Session Not Found',
          description: 'Redirecting you to start a new chat.',
        })
        startNewSession()
        navigate('/', { replace: true })
      } else {
        toast({
          variant: 'destructive',
          title: 'An error occurred',
          description: error,
        })
      }
    }
  }, [error, toast, navigate, startNewSession])

  return <ChatInterface />
}

export default ChatPage
